module.exports = __webpack_public_path__ + "img/CoverStory.58447f4c.jpg";